angular = require('angular')

app = angular.module('workflow.app')
app.directive('inlineEditor', require('./InlineEditor'))
